
/*eslint-disable*/
import Quote from './Quote'
import StockTable from '@/components/table/StockTable'
import ChangeTable from '@/components/table/ChangeTable'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { mapMutations, mapActions } from 'vuex'

export default {
  components: { StockTable, ChangeTable, Quote, ElImageViewer },
  props: {
    pageData: {},
    id: Number,
  },
  // head(){
  //   return {
  //     meta: [{ 'http-equiv': "Content-Security-Policy", content: "upgrade-insecure-requests" }]
  //   }
  // },
  data() {
    return {
      tabList: [
        {
          name: 'Details',
          isClick: false,
          isShow: true,
        },
        {
          name: 'Quick Quote',
          isClick: false,
          isShow: false,
        },
        {
          name: 'Stock',
          isClick: false,
          isShow: false,
        },
        {
          name: 'Resources',
          isClick: false,
          isShow: true,
        },
        {
          name: 'Changes',
          isClick: false,
          isShow: false,
        },
      ],
      typeTab: 0,
      stockData: [],
      showViewer: false,
      projectdDialogVisible: false,
      projectObj: {
        decoration_id: '',
      },
      // ticketFormVisible:false,
      ticketForm:{
        英文品名: this.pageData.product_name,
        SKU: this.pageData.product_code,
        问题类型: [],
        反馈详情: '',
      },
      ticketConfig: [
        { prop: '英文品名', type: 'text' },
        { prop: 'SKU', type: 'text' },
        {
          prop: '问题类型',
          type: 'checkbox',
          selectlist: ['网页信息','供应商质量','样品管理','产品部管理'],
        },
        { prop: '反馈详情', type: 'textarea' },
      ],
      rules: {
        '问题类型': [{ required: true, message: 'Please select', trigger: 'change' }],
        '反馈详情': [{ required: true, message: 'Please enter', trigger: 'blur' }]
      }
    }
  },
  computed: {
    currentPre(){
      return this.$store.state.product.smImgUlIdx
    },
    isLogin() {
      return !!this.$store.state.userInfo?.email
    },
    comInfo() {
      return this.pageData?.main
    },
    productImgArr() {
      return this.comInfo.mergeImages
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    comIncluded_packaging() {
      return this.comInfo.included_packaging.split(',')
    },
    comOptional_packaging() {
      return this.comInfo.optional_packaging.split(',')
    },
    comOptional_attachments() {
      return this.comInfo.optional_attachments.split(',')
    },
  },
  watch:{
    //登陆立即显示Quick Quote和Changes选项
    isLogin:{
      handler(val){
        if(val){
          this.tabList[1].isShow = true
          // this.tabList[4].isShow = true
        }
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions(['getUserInfo']),
    ...mapMutations({ openDialog: 'openDialog', setSmImgUlIdx: 'product/setSmImgUlIdx', setLoading: 'product/setLoading' }),
    // 判断字符串是否符合商品code规律
    isProduct(str) {
      return /^[A-z]{1,4}\d{1,4}[A-z]?$/.test(str)
    },
    computedIndex(i) {
      return this.pageData.main?.image ? 1 + i : i;
    },
    // 保存一下用户选择的周期、型号、打印服务、addon、packaging, product builder页面要用到
    saveUserSelected() {
      let result = {
        addon: [],
        packaging: [],
        printService: {},
      }
      for (let key in this.allSelData) {
        if (key === 'addon') {
          result.addon = this.allSelData[key].map(item => item.id)
        }
        if (key === 'packaging') {
          result.packaging = this.allSelData[key].map(item => item.id)
        }
      }
      // 周期
      if (this.priceList[this.currTab].cycle_id) {
        result.cycle = this.priceList[this.currTab].cycle_id
      }
      // 型号
      if (this.priceList[this.currTab].undecoratedSelectId) {
        result.model = this.priceList[this.currTab].undecoratedSelectId
      }
      // 打印服务
      const printService = this.priceList[this.currTab][2]
      console.log(printService, 'printService')
      if (Array.isArray(printService) && printService.length) {
        printService.forEach(item => {
          if (item.decorationSelectId) {
            const temp = item.decorationList.filter(
              i => i.id === item.decorationSelectId
            )
            result.printService[`${item.id}`] = {
              id: item.decorationSelectId,
              num: temp[0].num,
            }
          }
        })
      }
      localStorage.setItem(
        `product-user-select-${this.$route.params.code}`,
        JSON.stringify(result)
      )
    },
    // getStock() {
    //   this.$axios.get('/api/quote/stock_new', { params: {id: this.id} }).then(res => {
    //     this.stockData = res.result
    //   })
    // },
    openProjectdDialog() {
      if (!isLogin) {
        this.openDialog()
        return
      }
      this.projectdDialogVisible = true
      this.projectObj.cycle_id = this.comCurrPriceList.cycle_id
      this.projectObj.price_unit_id = this.comCurrPriceList.undecoratedSelectId
      //获取Decoration Method
      this.projectObj.decoration_methods = this.comDecoration.map(item => {
        let temp = {}
        temp.decoration_id = item.id
        temp.price_unit_id = item.parentId
        temp.colours_number = item.num
        return temp
      })

      this.projectObj.addition_ids = this.allSelData.addon
        .map(item => {
          return item.id
        })
        .join()
      this.projectObj.packaging_addition_ids = this.allSelData.packaging
        .map(item => {
          return item.id
        })
        .join()
    },
    download(url) {
      var urlStr = url.match('[^/]+(?!.*/)')[0]
      const repaceDomainUrl = this.$utils.repaceDomain(url)
      if (url.endsWith(".pdf")) {
        this.$utils.handleFileDownload(repaceDomainUrl, urlStr, false)
      } else {
        this.$utils.downloadBlob(url, urlStr)
      }
    },
    onPreview() {
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    },
    clickNav(i) {
      if (this.typeTab == 1 && !this.tabList[1].isClick) {
        this.checkNav(1)
      } else if (this.typeTab == 2 && !this.tabList[2].isClick) {
        this.checkNav(2)
      }
    },
    checkNav(i) {
      if (this.isLogin) {
        this.getUserInfo()
        if (this.userInfo.audit_status == 1) {
          if (i == 1) {
            this.$refs.quote.getQuote()
            // this.$refs.quote.getWeight()
            this.tabList[1].isClick = true
          } else if (i == 2) {
            // uk 没有这个
            // this.getStock()
            // this.tabList[2].isClick = true
          }
        } else {
          this.typeTab = 0
          this.$message({
            message: 'Your account has not been audited',
            type: 'warning',
          })
        }
      } else {
        this.openDialog()
        this.typeTab = 0
      }
    },
    openLink(url) {
      let a = url.indexOf('http') > -1 ? url : 'http://' + url
      window.open(a, '_blank')
    },
    // sendTicket() {
    //   this.$axios.post('/api/ticket/add', { product_code: this.pageData.product_code,ticket_type: this.ticketForm['问题类型'].join(),content: this.ticketForm['反馈详情']  }).then(res => {
    //     this.setLoading(false)
    //     this.$notify({
    //           title: "success",
    //           message: "提交成功",
    //           type: "success",
    //           duration: 3000,
    //         });
    //   }).catch(() => {
    //       this.setLoading(false)
    //     })
    // }
  },
}
